'use client';

import ErrorBoundary from '../components/error';
export default function AddV3({
  error
}: {
  error: Error & {
    digest?: string;
  };
}) {
  return <ErrorBoundary pagename="Create V3 Position" error={error} data-sentry-element="ErrorBoundary" data-sentry-component="AddV3" data-sentry-source-file="error.tsx" />;
}